module.exports = __webpack_public_path__ + "GN.png?81c74d29ec7d81ded7ce5e00ab0c9a6d";